// #region Imports
//Components
import { defineComponent } from "vue";
import { DxSelectBox, DxDropDownOptions } from 'devextreme-vue/select-box';
// #endregion
// #region Core
export default defineComponent({
    name: 'g-select-field',
    mixins: [host.mixins.form],
    components: {
        DxSelectBox,
        DxDropDownOptions
    },
    props: {
        itemSource: {
            type: Object,
            required: false,
            default: null,
        },
        valueExpr: {
            type: String,
            required: false,
            default: ''
        },
        itemTemplate: {
            type: String,
            required: false,
            default: 'item'
        },
        displayExpr: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        searchEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        mode: {
            type: String,
            required: false,
            default: 'text',
            validValues: ['text', 'password'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['text', 'password'].includes(value);
            }
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
        evalDisplayName(item) {
            return utils.evalExpression(item, this.displayExpr);
        },
        evalValue(item) {
            return utils.evalExpression(item, this.valueExpr);
        },
    }
});
// #endregion
